import React, { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Grid } from '@mui/material'
import phone from 'assets/icons/circles-design/Phone.svg'
import plan from 'assets/icons/circles-design/Plan.png'
import PageLayout from 'common/Layout/Page/PageLayout'
import { ColorBoxContent } from 'common/ui/colorBox'
import JoyrideContext from 'context/joyride/joyrideContext'

export default function StoreFront() {
  const joyrideContext = useContext(JoyrideContext)
  const { tourActive, setRun } = joyrideContext

  useEffect(() => {
    if (tourActive) {
      setTimeout(() => {
        setRun(true)
        // setStepIndex(6)
      }, 1000)
    }
  }, [])

  const navigate = useNavigate()

  return (
    <PageLayout header='Shop'>
      <Grid
        id='shopfront__catalogSection'
        container
        spacing={2}
        columns={{ xs: 6, md: 12 }}
      >
        <Grid item xs={12} md={6}>
          <div id='shopfront__buyNewSimSection'>
            <ColorBoxContent
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <img
                src={plan}
                alt='Plan'
                style={{
                  height: '100px',
                  padding: '1em'
                }}
              />
              <Button
                id='buySIMButton'
                variant='contained'
                aria-label='buy new sim'
                onClick={() => navigate('product-catalogue')}
              >
                Buy New SIMs
              </Button>
            </ColorBoxContent>
          </div>
        </Grid>

        <Grid item xs={12} md={6}>
          <div id='shopfront__comingSoon'>
            <ColorBoxContent
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <img
                src={phone}
                alt='Phones'
                style={{
                  height: '100px',
                  padding: '1em'
                }}
              />
              <Button
                disabled
                sx={{
                  border: 'none'
                }}
              >
                Coming Soon
              </Button>
            </ColorBoxContent>
          </div>
        </Grid>
      </Grid>
    </PageLayout>
  )
}
